import yup from 'utils/yup';

export const initialGeneralSettingsData = {
  company_name: '',
  allow_automatic_gps_clock_in: true,
  face_recognition_clock_in: true,
  job_clock_in: true,
  task_clock_in: true,
  mileage_in_km: true,
  time_off_in_menu: true,
  split_time: false,
  geofence_clock_in: true,
  block_website_clock_in: true,
  manual_breaks: true,
  mileage_clock_out: true,
  timezone: '' as any,
  date_format: '' as any,
  mileage_cost: 0,
  company_currency: '' as any,
  lunch_break_automatically: '' as any,
  lunch_break_duration: '' as any,
  auto_lunch_break: true,
  duration_lunch_break: true,
  clock_out_gps_off: false,
  clock_out_force_close_app: false,
  new_user_password_reset: false,
  driving_speed: 0,
  cali_break_policy: false,
  show_signature_sign_off: false,
  commuter_mileage: false,
  has_evv: false,
  allows_kiosk_app: false,
  custom_fields: false,
};

export const generalSettingsValidation = yup.object().shape({
  company_name: yup.string().required(),
  timezone: yup.string().required(),
  date_format: yup.string().required(),
  mileage_cost: yup.number().required(),
  company_currency: yup.string().required(),
  lunch_break_automatically: yup.string().when('manual_breaks', {
    is: false,
    then: yup.string().required(),
    otherwise: yup.string(),
  }),
  lunch_break_duration: yup.string().when('manual_breaks', {
    is: false,
    then: yup.string().required(),
    otherwise: yup.string().required(),
  }),
});
